import { useFeatureFlags } from './useFeatureFlags';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

/**
 * Composite frontend gate for the "Add to Allow/Block List" alert action
 * (KIR-3558). Mirrors the backend `isAddToListFromAlertsEnabled`: the action
 * depends on KIR-3529's `sourceDetails`, so it is enabled ONLY when BOTH
 * `add_to_list_from_alerts` and `alert_source_details` are on. This prevents a
 * partial rollout (one flag on, the other off) from half-enabling the feature.
 *
 * Single source of truth shared by the button (`AlertAddToListButton`) and the
 * alert table containers (which use it to decide whether to render the Actions
 * column at all), so the two can't drift.
 *
 * @returns `enabled` (both flags on) and `isLoading` (flags still resolving).
 */
export function useAddToListFromAlertsEnabled(): {
  enabled: boolean;
  isLoading: boolean;
} {
  const { flags, isLoading } = useFeatureFlags([
    flagsmithFeatureFlags.ADD_TO_LIST_FROM_ALERTS,
    flagsmithFeatureFlags.ALERT_SOURCE_DETAILS,
  ]);
  const enabled =
    (flags[flagsmithFeatureFlags.ADD_TO_LIST_FROM_ALERTS] ?? false) &&
    (flags[flagsmithFeatureFlags.ALERT_SOURCE_DETAILS] ?? false);
  return { enabled, isLoading };
}
